
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuMicasadecoTopMicasadecoImage } from "@src/constants/images";
import { meta as pancakePageMeta } from "./pancake.mdx";
export const meta = {
  path: "/media/harajuku/micasadeco",
  title: "【踊るパンケーキ！？】原宿のミカサデコカフェ(MICASADECO&CAFE)でふわふわパンケーキを食べよう！",
  description: "原宿で人気のパンケーキカフェを展開するのがミカサデコカフェ(MICASADECO&CAFE)。原宿と渋谷の間にあるキャットストリートに店舗を2020年に移転したこのお店は、「踊るパンケーキ」と言われるほどのふわふわのパンケーキがが食べられるお店として有名です！そんな、ミカサデコカフェ(MICASADECO&CAFE)についてまとめてみました！",
  topImg: harajukuMicasadecoTopMicasadecoImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "お店の紹介", "デート", "女子会", "スイーツ", "インスタ映え", "パンケーキ", "穴場", "裏原"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿と渋谷の間にあるキャットストリートに店舗を 2020 年に移転したこのお店、ミカサデコカフェ(MICASADECO&CAFE)。`}</p>
    <p>{`パンケーキ激戦区と言われる原宿で大人気で、インスタにもたくさん写真が上がっていることからその人気が伺えます！ミカサデコカフェ(MICASADECO&CAFE)は`}<strong parentName="p"><em parentName="strong">{`「踊るパンケーキ」`}</em></strong>{`と言われるほど、ふわふわパンケーキがが食べられるお店として有名です！`}</p>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)の名前の由来、人気メニュー、アクセスなどについてまとめてみましたのでぜひご覧ください！`}</p>
    <hr></hr>
    <h2>{`ミカサデコカフェ(MICASADECO&CAFE)とは？`}</h2>
    <InstaImage postId="B9qDzXqguvS" mdxType="InstaImage" />
    <p>{`東京、大阪、京都に３店舗を構えるパンケーキの人気店！`}</p>
    <p>{`東京では 2017 年にオープンし、2020 年 3 月に神宮前に場所を移転してリニューアルオープンしたお店です！
`}<strong parentName="p">{`大人が楽しめるカフェ`}</strong>{`をコンセプトに、1 番人気のパンケーキだけでなく、月替りのランチメニューなど、素材にこだわった食事が食べられるお店として人気上昇中です！`}</p>
    <h3>{`ミカサデコカフェ(MICASADECO&CAFE)の名前の由来`}</h3>
    <InstaImage postId="B-iuPpJg3G4" mdxType="InstaImage" />
    <p>{`MICASA(ミカサ)はスペイン語で`}<strong parentName="p">{`我が家`}</strong>{`を意味する言葉です！
たくさんの若者、外国人、カップルが、文化の交差点として生み出す原宿・表参道エリアで、新たな`}<strong parentName="p">{`くつろぎの場所になってほしい！`}</strong>{`という思いを込めているそうです…！`}</p>
    <hr></hr>
    <h2>{`踊るパンケーキ！？`}</h2>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)といえば、`}<strong parentName="p">{`踊るパンケーキ`}</strong>{`という異名を持つほど、皿を揺らすとふわふわと揺れるパンケーキが有名です！`}</p>
    <p>{`みてください！写真で見ただけで`}<strong parentName="p">{`ふわふわ`}</strong>{`さが伝わってきますよね！`}</p>
    <InstaImage postId="B96-YhuANg6" mdxType="InstaImage" />
    <h2>{`ミカサデコカフェ(MICASADECO&CAFE)のこだわり`}</h2>
    <p>{`店内の内装やパンケーキのデザインなどが他のお店とは大きく違うので、ご紹介させていただきます！`}</p>
    <h3>{`内装`}</h3>
    <p>{`グリーンとホワイトカラーを基調とし爽やかな雰囲気になっています！
`}<strong parentName="p">{`くつろぎの場所`}</strong>{`というように、落ち着いた雰囲気の店内ですよね！
窓際の席も光が差し込み、おだやかな気分にさせてくれる雰囲気。`}</p>
    <InstaImage postId="B5EX6-Hgo4Y" mdxType="InstaImage" />
    <h3>{`パンケーキのデザイン`}</h3>
    <h4>{`桜の並びらをモチーフに`}</h4>
    <InstaImage postId="B7-CF1vhU-g" mdxType="InstaImage" />
    <h4>{`ゆきだるまや鳥居をモチーフに`}</h4>
    <InstaImage postId="B5z9VJUHMHs" mdxType="InstaImage" />
    <h4>{`海の波をモチーフに`}</h4>
    <InstaImage postId="B79oJmYnL-C" mdxType="InstaImage" />
    <p>{`その他にもたくさんのデザインがあるので、当日はどんなデザインが出てくるか楽しみですよね！`}</p>
    <hr></hr>
    <h2>{`メニュー`}</h2>
    <h3>{`1 番人気のリコッタチーズパンケーキ(1,350 円)`}</h3>
    <InstaImage postId="BwJq_lVnIOh" mdxType="InstaImage" />
    <p>{`写真からインスタ映えすることがわかるパンケーキ！
素材にこだわり抜き、注文が入ってから一枚一枚焼き上げるパンケーキ。
出来上がりに揺らすとふわふわっと揺れ、口に入れると焼き上がりの温かさと甘みが口の中に充満します！`}</p>
    <h3>{`リンゴのコンポートパンケーキ(1,210 円)`}</h3>
    <InstaImage postId="B_kA2n5AMS7" mdxType="InstaImage" />
    <p>{`リンゴの素材の味をいかしたパンケーキになります！
リンゴだけでも、クリームと一緒に食べてもおいしいパンケーキになっています！`}</p>
    <h3>{`もちもちプレーンパンケーキ(930 円)`}</h3>
    <InstaImage postId="B90ODlEAuV1" mdxType="InstaImage" />
    <p>{`クラシックなパンケーキだらかこそ、お店の味が 1 番わかる一品になっています！
パンケーキの本来の味が食べたい！あまり大きな量は食べられない方は是非オススメです！`}</p>
    <h3>{`京都限定！抹茶 KYOTO 店オリジナルパンケーキ“Matcha” Fluffy(1,450 円)`}</h3>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)の京都店でしか食べられないのですが、抹茶を生地に練り込んだパンケーキ。
関西の方や関西に旅行に行った際には、抹茶がたくさん使われたこの限定パンケーキを是非食べてみてください！`}</p>
    <InstaImage postId="B75yK-Ugntv" mdxType="InstaImage" />
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`神宮前のキャットストリートに位置するお店で、神宮前から徒歩ですぐ行くことができます！
休日はすごい行列ができているので、すぐに見つけることができると思います！`}</p>
    <GoogleMap lat={35.6665261} lng={139.7032377} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`ミカサデコカフェ(MICASADECO&CAFE)についてお伝えしてきましたがいかがでしたでしょうか！？
名前の由来、ふわふわのパンケーキ、京都限定メニューなど、新しい発見が一つでもあればうれしいです！`}</p>
    <p>{`ぜひ、足を運んでみてください！`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;